import { HttpClient, HttpEvent, HttpParams, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { enpointCervinoWeb } from 'src/app/configuration/enpointsCervino';
import { PurchaseOrderImportModel } from 'src/app/models/imports/purchase-order-import.model';
import { LoadPreInvoicingModel } from 'src/app/models/invoicing/load-preinvoicing.models';
import { PreInvoicingAlertModel } from 'src/app/models/invoicing/pre-invoicing-alert.models';
import { ColumnResponseModel } from 'src/app/models/responses/column-response.model';
import { PagedResponseModel } from 'src/app/models/responses/paged-response.model';
import { PurchaseOrderPrintModel } from 'src/app/models/shopping/purchase-order-print.model';
import { PurchaseOrderModel } from 'src/app/models/shopping/purchase-order.model';
import { PurchaseOrderTableModel } from 'src/app/models/tables/shopping/purcharse-order-table.model';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class PurchaseOrderService {

  constructor(private _httpClient: HttpClient) { }

  annulPurchaseOrder(purchaseOrderId: number): Observable<PurchaseOrderModel> {
    const params = new HttpParams().set('purchaseOrderId', purchaseOrderId)
    return this._httpClient.put<PurchaseOrderModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.purchaseOrder.AnnulPurchaseOrder}`,
      null, { params: params }
    );
  }

  createPurchaseOrder(purchaseOrder: PurchaseOrderModel): Observable<PurchaseOrderModel> {
    return this._httpClient.post<PurchaseOrderModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.purchaseOrder.CreatePurchaseOrder}`,
      purchaseOrder);
  }

  deletePurchaseOrder(purchaseOrderId: number): Observable<PurchaseOrderModel> {
    const params = new HttpParams().set('purchaseOrderId', purchaseOrderId)
    return this._httpClient.delete<PurchaseOrderModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.purchaseOrder.DeletePurchaseOrder}`,
      { params: params }
    );
  }

  downloadGuideImport(): Observable<HttpEvent<Blob>> {
    return this._httpClient.request(new HttpRequest('GET', `${environment.apiCervinoBackend}${enpointCervinoWeb.purchaseOrder.DownloadGuideImport}`,
      null, { reportProgress: true, responseType: 'blob' }));
  }

  exportGeneralConsultation(filters: ColumnResponseModel[], columnSort: string | null, ascendant: boolean): Observable<Blob> {
    const params = new HttpParams()
      .set('columnSort', columnSort ?? '')
      .set('ascendant', ascendant.toString());

    return this._httpClient.post(`${environment.apiCervinoBackend}${enpointCervinoWeb.purchaseOrder.ExportGeneralConsultation}`, filters, {
      params,
      responseType: 'blob',
    });
  }

  exportImportErrors(alerts: PreInvoicingAlertModel[]): Observable<Blob> {
    return this._httpClient.post(`${environment.apiCervinoBackend}${enpointCervinoWeb.purchaseOrder.ExportImportErrors}`, alerts,
      {
        responseType: 'blob'
      }
    );
  }

  finalClosePurchaseOrder(purchaseOrderId: number): Observable<PurchaseOrderModel> {
    const params = new HttpParams().set('purchaseOrderId', purchaseOrderId)
    return this._httpClient.put<PurchaseOrderModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.purchaseOrder.FinalClosePurchaseOrder}`,
      null, { params: params }
    );
  }

  getColumnsForGeneralConsultation(): Observable<ColumnResponseModel[]> {
    return this._httpClient.get<ColumnResponseModel[]>(`${environment.apiCervinoBackend}${enpointCervinoWeb.purchaseOrder.GetColumnsForGeneralConsultation}`);
  }

  getFirstPurchaseOrderByKeys(branchId: number): Observable<PurchaseOrderModel> {
    const params = new HttpParams().set('branchId', branchId);

    return this._httpClient.get<PurchaseOrderModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.purchaseOrder.GetFirstPurchaseOrderByKeys}`,
      { params: params }
    );
  }

  getLastPurchaseOrderByKeys(branchId: number): Observable<PurchaseOrderModel> {
    const params = new HttpParams().set('branchId', branchId);

    return this._httpClient.get<PurchaseOrderModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.purchaseOrder.GetLastPurchaseOrderByKeys}`,
      { params: params }
    );
  }

  getNextPurchaseOrderByKeys(branchId: number, consecutive: number): Observable<PurchaseOrderModel> {
    const params = new HttpParams().set('branchId', branchId).set('consecutive', consecutive);

    return this._httpClient.get<PurchaseOrderModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.purchaseOrder.GetNextPurchaseOrderByKeys}`,
      { params: params }
    );
  }

  getPreviusPurchaseOrderByKeys(branchId: number, consecutive: number): Observable<PurchaseOrderModel> {
    const params = new HttpParams().set('branchId', branchId).set('consecutive', consecutive);

    return this._httpClient.get<PurchaseOrderModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.purchaseOrder.GetPreviusPurchaseOrderByKeys}`,
      { params: params }
    );
  }

  getPurchaseOrderById(purchaseOrderId: number): Observable<PurchaseOrderModel> {
    const params = new HttpParams().set('purchaseOrderId', purchaseOrderId);

    return this._httpClient.get<PurchaseOrderModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.purchaseOrder.GetPurchaseOrderById}`,
      { params: params }
    );
  }

  getPurchaseOrderByKeys(branchId: number, consecutive: number): Observable<PurchaseOrderModel> {
    const params = new HttpParams().set('branchId', branchId).set('consecutive', consecutive);

    return this._httpClient.get<PurchaseOrderModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.purchaseOrder.GetPurchaseOrderByKeys}`,
      { params: params }
    );
  }

  getPurchaseOrdersForGeneralConsultation(page: number, limit: number, columnSort: string | null, ascendant: boolean, filters: ColumnResponseModel[]): Observable<PagedResponseModel<PurchaseOrderTableModel>> {
    const params = new HttpParams()
      .set('page', page)
      .set('limit', limit)
      .set('columnSort', columnSort || '')
      .set('ascendant', ascendant);

    return this._httpClient.post<PagedResponseModel<PurchaseOrderTableModel>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.purchaseOrder.GetPurchaseOrdersForGeneralConsultation}`,
      filters, { params: params }
    );
  }

  importPurchaseOrder(purchaseOrderImports: Array<PurchaseOrderImportModel>): Observable<LoadPreInvoicingModel> {
    return this._httpClient.post<LoadPreInvoicingModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.purchaseOrder.ImportPurchaseOrdersAsync}`,
      purchaseOrderImports
    );
  }

  initialClosePurchaseOrder(purchaseOrderId: number): Observable<PurchaseOrderModel> {
    const params = new HttpParams().set('purchaseOrderId', purchaseOrderId)
    return this._httpClient.put<PurchaseOrderModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.purchaseOrder.InitialClosePurchaseOrder}`,
      null, { params: params }
    );
  }

  printPurchaseOrder(purchaseOrderId: number): Observable<PurchaseOrderPrintModel> {
    return this._httpClient.get<PurchaseOrderPrintModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.purchaseOrder.PrintPurchaseOrder}/${purchaseOrderId}`);
  }

  reverseStatePurchaseOrder(purchaseOrderId: number): Observable<PurchaseOrderModel> {
    const params = new HttpParams().set('purchaseOrderId', purchaseOrderId)
    return this._httpClient.put<PurchaseOrderModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.purchaseOrder.ReverseStatePurchaseOrder}`,
      null, { params: params }
    );
  }

  updatePurchaseOrder(purchaseOrder: PurchaseOrderModel): Observable<PurchaseOrderModel> {
    return this._httpClient.put<PurchaseOrderModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.purchaseOrder.UpdatePurchaseOrder}`,
      purchaseOrder);
  }
}
